import 'v-title/lib/element-ui'
import Vue from 'vue'
import VTitle from 'v-title'

Vue.use(VTitle)
